import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import More from './more';

class About extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.about}>
                <div className={styles.summary}>{content.content}</div>
                <More content={content.content} />
            </div>
        );
    }
}

const AboutChip = props => {
    return (
        <Chip id="230216" type="struct" title="美食盛典-介绍" groupName="正文-首页" content={props.content}>
            <About />
        </Chip>
    );
};

AboutChip.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(AboutChip);
